/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/* vpn-intelligence/assets/js/vpn.js — network composition dashboard + visitor lookup.
 * Expects the DOM from frontend/pages.php (data-vpn="…" hooks). Uses window.GS.api. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["vpn-intelligence"] = "1.1.5"; } catch (e) {}

  var CAT = {
    residential: { l: TR('vpnint.g.residential'), c: "#1FA463" }, datacenter: { l: TR('vpnint.g.datacenter_cloud'), c: "#8B5CF6" },
    vpn: { l: "VPN", c: "#D97706" }, proxy: { l: TR('vpnint.g.proxy'), c: "#DC2626" }, tor: { l: "Tor", c: "#111827" },
    other: { l: TR('vpnint.g.other'), c: "#94A3B8" }
  };
  var BAND = { low: "#1FA463", medium: "#D97706", high: "#F97316", critical: "#DC2626" };
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function num(n) { return (+n || 0).toLocaleString(); }
  function typeCat(t) { return (t === "hosting" || t === "cdn") ? "datacenter" : ((t === "isp" || t === "carrier") ? "residential" : (CAT[t] ? t : "other")); }

  function ctl() {
    var d = document;
    return {
      rangeBtn: d.querySelector('[data-vpn="rangeBtn"]'), rangeMenu: d.querySelector('[data-vpn="rangeMenu"]'), rangeLabel: d.querySelector('[data-vpn="range-label"]'),
      vh: d.querySelector('[data-vpn="vh"]'), lookup: d.querySelector('[data-vpn="lookup"]'),
      cats: d.querySelector('[data-vpn="cats"]'), clusters: d.querySelector('[data-vpn="clusters"]'),
      visitor: d.querySelector('[data-vpn="visitor"]'), depnote: d.querySelector('[data-vpn="depnote"]')
    };
  }

  function init() {
    if (document.body._vpnWired || !window.GS || !GS.api) return;
    document.body._vpnWired = 1;
    var c = ctl(); if (!c.cats) return;

    function _rpT(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
    function _rpYmd(d){return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2);}
    function _rpToday(){var n=new Date();return new Date(Date.UTC(n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()));}
    function preset(days){var to=_rpToday(),from=new Date(to.getTime()-(days-1)*86400000);var lbl={7:_rpT("an.last7"),30:_rpT("an.last30"),90:_rpT("an.last90"),365:_rpT("an.last12mo")}[days]||(days+" days");return {from:_rpYmd(from),to:_rpYmd(to),label:lbl,preset:String(days)};}
    var RANGE=(function(){try{var s=JSON.parse(localStorage.getItem("gs_vpn_range")||"null");if(s&&s.preset)return preset(+s.preset);if(s&&s.from&&s.to)return s;}catch(e){}return preset(30);})();
    function _rpInit(){
      var btn=document.querySelector('[data-vpn="rangeBtn"]'),menu=document.querySelector('[data-vpn="rangeMenu"]'),lab=document.querySelector('[data-vpn="range-label"]');
      if(!btn||!menu)return;
      if(lab&&RANGE.label)lab.textContent=RANGE.label;
      function sync(){menu.querySelectorAll(".rm[data-preset]").forEach(function(x){x.classList.toggle("on",x.getAttribute("data-preset")===RANGE.preset);});}
      btn.addEventListener("click",function(e){if(menu.contains(e.target)&&e.target!==btn)return;e.stopPropagation();var open=menu.style.display!=="none";menu.style.display=open?"none":"block";if(!open){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf)cf.value=RANGE.from;if(ct)ct.value=RANGE.to;sync();}});
      document.addEventListener("click",function(e){if(!btn.contains(e.target))menu.style.display="none";});
      function apply(r){RANGE=r;if(lab)lab.textContent=RANGE.label;try{localStorage.setItem("gs_vpn_range",JSON.stringify(RANGE));}catch(e){}menu.style.display="none";load();}
      menu.querySelectorAll(".rm[data-preset]").forEach(function(b){b.addEventListener("click",function(){apply(preset(+b.getAttribute("data-preset")));});});
      var ap=menu.querySelector('[data-rp="apply"]');if(ap)ap.addEventListener("click",function(){var ff=menu.querySelector('[data-rp="from"]').value,tt=menu.querySelector('[data-rp="to"]').value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}apply({from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null});});
    }

    function stackBar(cats) {
      var order = ["residential", "datacenter", "vpn", "proxy", "tor", "other"];
      return '<div class="vpn-bar">' + order.map(function (k) {
        var p = (cats[k] && cats[k].pct) || 0;
        return p > 0 ? '<span style="width:' + p + '%;background:' + CAT[k].c + '" title="' + CAT[k].l + " " + p + '%"></span>' : "";
      }).join("") + "</div>";
    }
    function catCards(cats) {
      return ["residential", "datacenter", "vpn", "proxy", "tor"].map(function (k) {
        var o = cats[k] || { sessions: 0, pct: 0 };
        return '<div class="col-6 col-md"><div class="vpn-stat">' +
          '<div class="vpn-stat-dot" style="background:' + CAT[k].c + '"></div>' +
          '<div class="vpn-stat-v">' + o.pct + '%</div>' +
          '<div class="vpn-stat-l">' + CAT[k].l + "</div>" +
          '<div class="vpn-stat-n">' + num(o.sessions) + " sessions</div></div></div>";
      }).join("");
    }
    function renderSegment(d) {
      if (!d || !d.ok) { c.cats.innerHTML = '<div class="col-12"><div class="gs-muted small">'+TR('vpnint.g.no_data')+'</div></div>'; return; }
      var cats = d.categories || {}, total = d.total || 0;
      if (c.depnote) c.depnote.hidden = total > 0;
      c.cats.innerHTML =
        '<div class="col-12"><div class="gs-card"><div class="gs-card-body">' +
          '<div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">' +
            '<div class="fw-semibold">'+TT('vpni.js.network_composition')+'</div>' +
            '<div class="gs-muted small">' + num(total) + " sessions &middot; <strong>" + num(d.country_mismatch_visitors || 0) + "</strong> country-mismatch visitors</div>" +
          "</div>" + stackBar(cats) +
          '<div class="row g-2 mt-1">' + catCards(cats) + "</div>" +
        "</div></div></div>";
    }

    function typeBadge(t) { var m = CAT[typeCat(t)]; return '<span class="vpn-badge" style="background:' + m.c + '22;color:' + m.c + '">' + esc(t) + "</span>"; }
    /* "Medium" invites the question "why?", so the badge carries the arithmetic the backend used:
       the network type it is based on, plus any country-mismatch or rotation penalties. */
    function riskBadge(score, band, why) {
      var col = BAND[band] || "#94A3B8";
      var t = why || ((band || "") + " risk (" + (+score || 0) + "/100)");
      return '<span class="vpn-riskwrap" title="' + esc(t) + '" tabindex="0">'
           + '<span class="vpn-risk" style="background:' + col + '"></span> ' + (+score || 0) + "</span>";
    }
    function renderClusters(cl) {
      function vpnRow(x) {
        return "<tr><td>AS" + x.asn + '</td><td class="text-truncate" style="max-width:170px" title="' + esc(x.provider) + '">' + esc(x.provider || "—") + "</td>" +
          "<td>" + typeBadge(x.type) + "</td><td>" + num(x.sessions) + "</td><td>" + num(x.visitors) + "</td>" +
          "<td>" + riskBadge(x.risk_score, x.risk_band, x.risk_why) + "</td></tr>";
      }
      if (window.GSMore) GSMore.mount({ container: c.clusters, table: true, colspan: 6, items: cl || [], pageSize: 20, emptyText: TR('vpnint.f2.no_high_risk_network_clusters_in_t'), render: vpnRow });
      else c.clusters.innerHTML = (cl && cl.length) ? cl.map(vpnRow).join("") : '<tr><td colspan="6" class="gs-muted">'+TR('vpnint.f2.no_high_risk_network_clusters_in_t')+'</td></tr>';
    }

    function stateReason(d) {
      if (!d) return TR('vpnint.p.couldn_t_load_this_right_now_please_');
      if (d.gated) return "VPN & Proxy Intelligence isn't available on your current plan.";
      if (d.error === "plugin_not_loaded") return "VPN & Proxy Intelligence isn't enabled for this site yet. Enable it under Plugins — an admin may need to enable & grant it, then re-sync the plugin registry.";
      if (!d.ok) return TR('vpnint.p.couldn_t_load_this_right_now_please_');
      return null;
    }
    function showDep(msg) {
      if (!c.depnote) return; c.depnote.hidden = false;
      c.depnote.innerHTML = '<div class="gs-card-body"><div class="fw-semibold mb-1"><i class="bi bi-info-circle me-1"></i>' + esc(msg) + "</div></div>";
    }

    function load() {
      if (!GS.site) return;   // GS.site is null until gs:ready; the gs:ready/site-change handlers re-fire this
      var q = "/plugin/vpn-intelligence/segment?site=" + encodeURIComponent(GS.site || "") + "&from=" + RANGE.from + "&to=" + RANGE.to;
      GS.api(q).then(function (r) {
        var d = r.data || null, reason = stateReason(d);
        if (reason) { showDep(reason); c.cats.innerHTML = ""; c.clusters.innerHTML = ""; return; }
        if ((d.total || 0) === 0) showDep(TR('vpnint.f2.no_network_data_in_this_range_yet_'));
        else if (c.depnote) c.depnote.hidden = true;
        renderSegment(d); renderClusters(d.clusters);
      });
    }

    function renderVisitor(d) {
      var s = d.score, col = BAND[s.risk_band] || "#94A3B8", flags = [];
      if (s.is_vpn) flags.push("VPN"); if (s.is_proxy) flags.push(TR('vpnint.g.proxy')); if (s.is_tor) flags.push("Tor");
      if (s.is_datacenter) flags.push(TR('vpnint.g.datacenter')); if (s.is_residential) flags.push(TR('vpnint.g.residential'));
      if (s.country_mismatch) flags.push(TR('vpnint.g.country_mismatch'));
      c.visitor.innerHTML =
        '<div class="vpn-vhead"><div class="vpn-gauge" style="--c:' + col + '"><span>' + s.risk_score + "</span></div>" +
          '<div><div class="fw-semibold">Risk ' + esc(s.risk_band) + '</div><div class="gs-muted small">Anonymization ' + esc(s.anonymization) + " &middot; Reputation " + s.reputation + " &middot; Noise " + esc(s.noise_level) + "</div></div></div>" +
        '<div class="vpn-flags">' + flags.map(function (f) { return '<span class="vpn-chip">' + esc(f) + "</span>"; }).join("") + "</div>" +
        '<table class="vpn-kv"><tr><td>'+TT('vpni.js.latest_network')+'</td><td>' + esc(d.latest.provider || "—") + (d.latest.asn ? ' <span class="gs-muted">AS' + d.latest.asn + "</span>" : "") + "</td></tr>" +
          "<tr><td>" + TR('vpnint.g.type') + "</td><td>" + esc(d.latest.provider_type) + "</td></tr>" +
          "<tr><td>" + TR('vpnint.g.countries') + "</td><td>" + (d.countries.length ? d.countries.map(esc).join(", ") : "—") + "</td></tr>" +
          "<tr><td>" + TR('vpnint.g.asns_seen') + "</td><td>" + (d.asns.length ? d.asns.map(function (a) { return "AS" + a; }).join(", ") : "—") + "</td></tr>" +
          "<tr><td>" + TR('vpnint.g.sessions') + "</td><td>" + num(d.sessions) + "</td></tr></table>" +
        '<a class="btn btn-outline-secondary btn-sm mt-2" href="/visitor-intelligence?vh=' + encodeURIComponent(d.visitor) + '"><i class="bi bi-person-badge"></i> View in Visitor Intelligence</a>';
    }
    function lookup() {
      if (!GS.site) return;
      var vh = (c.vh.value || "").trim(); if (!vh) return;
      c.visitor.innerHTML = '<div class="gs-muted small">Looking up&#8230;</div>';
      GS.api("/plugin/vpn-intelligence/visitor?site=" + encodeURIComponent(GS.site || "") + "&vh=" + encodeURIComponent(vh)).then(function (r) {
        var d = (r.ok && r.data) || {};
        if (d.limited) { c.visitor.innerHTML = '<div class="alert alert-warning small mb-0">' + esc(d.message || "View limit reached.") + "</div>"; return; }
        if (d.error || !d.score) { c.visitor.innerHTML = '<div class="gs-muted small">'+TR('vpnint.f2.no_sessions_found_for_that_visitor')+'</div>'; return; }
        renderVisitor(d);
      });
    }

    _rpInit();
    if (c.lookup) c.lookup.addEventListener("click", lookup);
    if (c.vh) c.vh.addEventListener("keydown", function (e) { if (e.key === TR('vpnint.g.enter')) lookup(); });
    var _deepVh = null; try { _deepVh = new URLSearchParams(location.search).get("vh"); } catch (e) {}
    function first() { if (!GS.site) return; load(); if (_deepVh && c.vh) { c.vh.value = _deepVh; _deepVh = null; lookup(); } }
    document.addEventListener("gs:ready", first);
    document.addEventListener("gs:site-change", load);
    first();
  }

  function boot() { if (document.querySelector('[data-vpn="cats"]')) init(); }
  /* Boot ONCE, after main.js resolves GS.site. The old DOMContentLoaded path raced that,
     firing every request with an empty site= (404) and then booting again on gs:ready. */
  var _booted = false;
  function _bootOnce() { if (_booted) return; _booted = true; boot(); }
  document.addEventListener("gs:ready", _bootOnce, { once: true });
  if (window.GS && GS.site) _bootOnce();
})();
